/* eslint-disable no-param-reassign */
/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */

import {
  sendInfo as sentryInfo,
  sendError as sentryError,
  sendWarning as sentryWarning,
} from '@/services/vendors/sentry';

// initial state
const state = {
};

// getters
const getters = {
};

// actions
const actions = {
  /**
   * Send info to sentry
   * @param {Object}
   * @param {Error} error
   * @param {String} stepname
   */
  sendInfo({ rootGetters }, { err, currentPage }) {
    sentryInfo({ info: err, currentPage, additionalData: rootGetters.sentry });
  },
  /**
   * Send warning to sentry
   * @param {Object}
   * @param {Error} error
   * @param {String} stepname
   */
  sendWarning({ rootGetters }, { err, currentPage }) {
    sentryWarning({ warning: err, currentPage, additionalData: rootGetters.sentry });
  },
  /**
   * Send error to sentry
   * @param {Object}
   * @param {Error} error
   * @param {String} stepname
   */
  sendError({ rootGetters }, { err, currentPage }) {
    sentryError({
      err,
      currentPage,
      additionalData: rootGetters.sentry,
    });
  },
};

// mutations
const mutations = {
  SET_ERROR(state, message) {
    state.message = message;
  },
  UNSET_RESTART(state) {
    state.haveRestart = false;
  },
  SET_RESTART(state) {
    state.haveRestart = true;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
